const getLocationName = location => {
  const { type, key, name } = location;
  return type === 'Building' ? key : name;
};

export default getLocationName;
